import { Box, Button, Center, HStack, Stack } from "@chakra-ui/react";
import React, { FC } from "react";
import ReactMarkdown from "react-markdown";
import { HeadingHero } from "../styles";
import { Link } from "gatsby";
import useNotfoundAttrQuery from "../hooks/useNotfoundAttrQuery";
import { If, Then } from "react-if";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import ActionButton from "@modules/Layout/components/ActionButton";

const Cover: FC = () => {
  const { data: result } = useNotfoundAttrQuery();
  const { banner } = result!.data.attributes;

  const coverImage =
    banner.heading_bg?.data?.attributes?.formats?.large?.webp?.url;

  return (
    <HeadingHero>
      <Box
        pt={0}
        pb={10}
        px={4}
        height={"xl"}
        position="relative"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={`url(${coverImage})`}
      >
        <Stack alignItems="center" justifyContent="center" height="100%">
          <ReactMarkdown children={banner.content}></ReactMarkdown>

          <ActionButton actions={banner.action} />
        </Stack>
      </Box>
    </HeadingHero>
  );
};

export default Cover;
